import { gReactive } from '@gradin/vue-utils'
import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useProductGroupList () {
  const api = useApi()
  const productGroups = ref<ProductGroup[]>([])
  const loading = ref(false)

  const getData = async (params = {}) => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<ProductGroup>>('admin/product-group', params)
      productGroups.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    productGroups,
  }
}

const form = gReactive<ProductGroupForm>({
  name: '',
  enable_sw: true,
})

export function useProductGroupCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitForm = async () => {
    try {
      submitting.value = true
      return await api.POST<ProductGroup>('admin/product-group', form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useProductGroupEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      return await api.PUT<ProductGroup>(`admin/product-group/${id}`, form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useProductGroupDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitDelete = async (id: number) => {
    try {
      submitting.value = true
      await api.DELETE(`admin/product-group/${id}`)
      return id
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
  }
}
